import * as types from '../types'
import axiosV3 from '@/clientAPIV3.ts'

export const TRANSLATE_API = {
    getTranslation: async ({
        contents,
        target
    }: types.GetTranslationProps): Promise<{contents: types.GetTranslationRequest[]}> => {
        const {data} = await axiosV3.post(`/translations`, {contents, target})
        return data
    }
}
